module.exports = __webpack_public_path__ + "static/media/icon-user-circle-lg.efabb83e.svg";